import { Button, List } from 'antd';
import CustomListItem from 'app/components/CustomListItem/CustomListItem';
import React from 'react';
import { useFieldList } from './hooks/useFieldList';
import * as S from './FieldList.styled';

type Props = {
  searchQuery: string;
};

const FieldList: React.FC<Props> = ({ searchQuery }) => {
  const {
    fieldListDataWithSearchApplied,
    t,
    loading,
    activeFieldId,
    openFieldDetails,
    onFieldListItemClick,
  } = useFieldList({ searchQuery });
  return (
    <>
      <List
        loading={loading}
        itemLayout="horizontal"
        dataSource={fieldListDataWithSearchApplied}
        renderItem={({ fieldId, name, area, isVisible }) => (
          <CustomListItem
            id={`fieldItem${fieldId}`}
            isActive={activeFieldId === fieldId}
            isVisible={isVisible}
            key={fieldId}
            onClick={onFieldListItemClick(fieldId)}
            actions={[
              <Button key="0" onClick={openFieldDetails(fieldId)} type="link">
                <S.FieldDetailsBtnIcon
                  title={t('Field.List.DetailsBtn', 'Details')}
                />
              </Button>,
            ]}
          >
            <List.Item.Meta title={name} description={area} />
          </CustomListItem>
        )}
      />
    </>
  );
};

export default FieldList;
